import React from "react";
export const CurrentUserContext = React.createContext(null);
export const isAuthenticated = React.createContext(false);
